<template>
    <Modal
        id="view-audit-modal"
        ref="viewAuditModal"
        v-model:open="open"
        :title="$t('view_audit')"
    >
        <div
            class="flex h-auto w-full flex-col items-start justify-start space-y-3"
        >
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('auditable_type') }}:</p>
                <p class="text-sm">{{ audit.auditable_type.split('\\')[2] }}</p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('auditable_id') }}:</p>
                <p class="text-sm">{{ audit.auditable_id }}</p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('user_id') }}:</p>
                <p class="text-sm">{{ audit.user_id }}</p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('event') }}:</p>
                <p class="text-sm">{{ audit.event }}</p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="whitespace-no-wrap text-sm font-semibold">
                    {{ $t('user_agent') }}:
                </p>
                <p class="whitespace-pre-wrap break-all text-sm">
                    {{ audit.user_agent }}
                </p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('ip_address') }}:</p>
                <p class="text-sm">{{ audit.ip_address }}</p>
            </div>
            <div
                v-if="
                    audit.old_values && Object.keys(audit.old_values).length > 0
                "
                class="flex h-auto w-full flex-col items-start justify-start space-y-2 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-bold">{{ $t('old_values') }}:</p>
                <div
                    v-for="value in Object.keys(audit.old_values as Record<string, unknown>)"
                    :key="value"
                    class="bg-primary-additional-50 flex h-auto w-full flex-col items-start justify-start rounded-md px-4 py-2 text-sm"
                >
                    <p class="font-semibold">{{ value }}:</p>
                    <p class="whitespace-pre-wrap break-all">
                        {{ audit.old_values && audit.old_values[value] }}
                    </p>
                </div>
            </div>
            <div
                v-else
                class="flex h-auto w-full flex-col items-start justify-start space-y-2 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-bold">{{ $t('old_values') }}: Empty</p>
            </div>
            <div
                class="flex h-auto w-full flex-col items-start justify-start space-y-2 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-bold">{{ $t('new_values') }}:</p>
                <div
                    v-for="value in Object.keys(audit.new_values as Record<string, unknown>)"
                    :key="value"
                    class="bg-primary-additional-50 flex h-auto w-full flex-col items-start justify-start rounded-md px-4 py-2 text-sm"
                >
                    <p class="font-semibold">{{ value }}:</p>
                    <p class="whitespace-pre-wrap break-all">
                        {{ audit.new_values && audit.new_values[value] }}
                    </p>
                </div>
            </div>
        </div>
    </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@src/components'
import { Audit } from '@src/utils/api/audits'
import { useVModels } from '@vueuse/core'

const props = withDefaults(
    defineProps<{
        open: boolean
        audit: Audit
    }>(),
    {
        open: false,
    }
)

const emit = defineEmits(['update:open'])

const { open } = useVModels(props, emit)
</script>
